import request from '@/utils/request'

// 短信套餐列表：GET（含余额）
export function smsPackageList() {
  return request.get('/sms/smsPackageList')
}

// 创建短信套餐订单：POST package_id
export function smsBuyOrder(packageId) {
  return request.post('/sms/buyOrder', { package_id: packageId })
}

// 我的短信购买订单列表：GET status page limit
export function smsOrderList(params) {
  return request.get('/sms/orderList', { params: params || {} })
}

// 短信余额：GET
export function smsBalance() {
  return request.get('/sms/balance')
}

// 读取机构短信配置：GET
export function smsGetCompanyConfig() {
  return request.get('/sms/getCompanyConfig')
}

// 保存机构短信配置：POST sign template secret_id secret_key sdk_app_id
export function smsSaveCompanyConfig(data) {
  return request.post('/sms/saveCompanyConfig', data)
}

// 支付发起（复用续费支付通道）：GET order_id paytype
export function smsPay(orderId, paytype) {
  return request.get('/recharge/pay', { params: { order_id: orderId, paytype } })
}

// 逾期客户筛选（群发前预览）：GET name phone start_date end_date page limit
export function smsOverdueList(params) {
  return request.get('/sms/overdueList', { params: params || {} })
}

// 创建群发任务：POST title send_time(name/phone/start_date/end_date 筛选)，签名/模板由平台统一
export function smsCreate(data) {
  return request.post('/sms/create', data)
}

// 任务列表：GET status page limit
export function smsTaskList(params) {
  return request.get('/sms/taskList', { params: params || {} })
}

// 任务发送明细：GET task_id status page limit
export function smsTaskDetail(params) {
  return request.get('/sms/taskDetail', { params: params || {} })
}